// import { renderRequiredRule } from "@/utils/renderRulesForm";

export default (services) => ({
  powerOfAttorney: false,
  typePowerOfAttorney: [
    {
      validator: (rule, value, callback) => {
        if (services.powerOfAttorney && value === "") {
          callback(new Error("Пожалуйста выберите доверенность"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  dataForTheDriver: false,
  sendTo: [
    {
      validator: (rule, value, callback) => {
        if (services.dataForTheDriver && value === "") {
          callback(new Error("Пожалуйста выберите способ"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  cashOnDelivery: false,
  cashOnDeliverySum: [
    {
      validator: (rule, value, callback) => {
        if (services.cashOnDelivery && (value === null || value.length === 0)) {
          callback(new Error("Пожалуйста введите сумму"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  cargoRedemption: false,
  cargoRedemptionSum: [
    {
      validator: (rule, value, callback) => {
        if (services.cargoRedemption && (value === null || value.length === 0)) {
          callback(new Error("Пожалуйста введите сумму"));
        }
        callback();
      },
      type: Number,
      trigger: "blur",
    },
  ],
  whoPaysTheRansom: [
    {
      validator: (rule, value, callback) => {
        if (services.cargoRedemption && value === "") {
          callback(new Error("Пожалуйста выберите плательщика"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  returnOfDocuments: false,
});
